import { createFileRoute } from '@tanstack/react-router'
import { RoutinesListPage } from '@/features/havi-routines/routines-list-page'

export const Route = createFileRoute(
  '/_authenticated/_organization/havi/routines/'
)({
  component: RoutinesListPage,
})
